<template>
    <v-navigation-drawer
            app
            v-model="drawerStatus"
            :mini-variant="sideBarStatus"
            :permanent="sideBarStatus"
            :temporary="!sideBarStatus"
            :stateless="true"
            v-if="enabled"
        >
            <v-list-item class="px-2">
            <v-list-item-avatar>
                <v-img :src="this.localUserDb.photo"></v-img>
            </v-list-item-avatar>
    
            <v-list-item-title>{{ this.localUserDb.displayname }}</v-list-item-title>
    
            <v-btn
                icon
                @click.stop="modifySidebar(!sideBarStatus)"
            >
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            </v-list-item>

            <v-list-item v-if="!sideBarStatus">
            <v-row no-gutters>
              <v-col cols="12" md="5" sm="0">
                <v-btn class="pa-0" text small @click="viewProfile(localUserDb)">
                  <v-icon left color="primary">mdi-account</v-icon>
                  My Profile
                </v-btn>
              </v-col>     
              <v-col cols="12" md="2" sm="1">
              <v-divider
              class="ml-4"
              xs
              vertical
              ></v-divider>
              </v-col>
              <v-col cols="12" md="5" sm="2">
                <!-- Add a greyed out v-if / style to this if the user doesn't have an orgId -->
                <v-btn :disabled="!hasOrganisation" class="pa-0" text small @click="viewOrganisation(localOrgDb)">
                  <v-icon left color="primary">mdi-domain</v-icon>
                  {{organisationName}}
                </v-btn>

              </v-col>
            </v-row>
            </v-list-item>
    
            <v-divider></v-divider>
    
            <v-list dense>
            <v-list-item
                v-for="item in navItems"
                :key="item.title"
                link
                v-on:click="pushRoute(item.route);"
            >
                <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
    
                <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            
            <v-list-item v-if= !sideBarStatus link 
            router
            v-on:click="signOut()"
            :to="loginPath">
                <v-list-item-icon>
                <v-icon>mdi-logout-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>Sign Out</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            </v-list>

        <v-dialog v-model="viewProfileDialog" class="overflow: hidden" :retain-focus="false" fullscreen hide-overlay transition="dialog-bottom-transition">              
          <profile-screen
          v-if="viewProfileDialog"
          v-on:dialogClosed="closeViewProfile()"
          :user="localUserDb"
          label="My"
          :myProfile="true">
          </profile-screen>
        </v-dialog>

        <v-dialog v-model="viewOrganisationDialog" :retain-focus="false" fullscreen hide-overlay transition="dialog-bottom-transition">              
            <organisation-screen
            v-if="viewOrganisationDialog"
            v-on:dialogClosed="closeViewOrganisation()"
            :user="localUserDb"
            :org="localOrgDb"
            :label="localOrgDb.name">
            </organisation-screen>
        </v-dialog>            
    </v-navigation-drawer>
</template>

<script>
import ProfileScreen from './../Management/ProfileScreen.vue'
import OrganisationScreen from './../Management/OrganisationScreen.vue'

  export default {
    data () {
      return {
        drawer: true,
        loginPath: '/loginPage',
        currentProfileInformation: {},
        currentOrganisationInformation: {},
        viewProfileDialog: false,
        viewOrganisationDialog: false,
        localUserDb: {},
        localOrgDb: {}
      }
    },
    components: {
      ProfileScreen,
      OrganisationScreen
    },
    props: 
    {
      navItems: Array,
      mini: Boolean,
      enabled: Boolean,
      userDb: Object,
      orgDb: Object
    },
    methods: {
      modifySidebar(newStatus) {
        this.sideBarStatus = newStatus;
        console.log("Emitted!"); // eslint-disable-line no-console
        this.$emit("sidebarEmit", newStatus);
      },
      signOut(){
        this.$emit("signOut", false);
      },
      pushRoute(route){
        //This should keep the new DB's correct? Just check we don't need a watcher or anything for the userDB. How do we stop stale data when 'sitting' on the dashboard screen? As that is obtained from loading
        this.$router.push({ name: route.name, params: { user: this.$route.params.user, loggedInStatus: this.$route.params.loggedInStatus, userDb: this.userDb, orgDb: this.orgDb} });
      },
      viewProfile(userDatabase){
        //Placeholder function --> If the dialog is opened above, it may do some fetching/calculation of the data needed in the currentProfileInformation object
        this.viewProfileDialog = true;
        console.log("Viewing Profile for: " + userDatabase.displayname); //eslint-disable-line no-console
      },
      closeViewProfile(){
        //Close the profile dialog (and clear?)
        this.viewProfileDialog = false;
      },
      viewOrganisation(orgDatabase){
        //Placeholder function --> If the dialog is opened above, it may do some fetching/calculation of the data needed in the currentOrganisationInformation object
        this.viewOrganisationDialog = true;
        console.log("Viewing Profile for: " + orgDatabase.name); //eslint-disable-line no-console
      },
      closeViewOrganisation(){
        //Close the profile dialog (and clear?)
        this.viewOrganisationDialog = false;
      },
      isSmallScreen(){
        switch (this.$vuetify.breakpoint.name) {
              case 'xs': return false
              case 'sm': return true
              case 'md': return true
              case 'lg': return true
              case 'xl': return true
        }
      },
      UpdateRouteParams(newUserDb, newOrgDb){
         //Function to update the current $route.params --> This could also be done via the App.vue? However we could classify this Nav as the central place for update
         //https://router.vuejs.org/guide/essentials/navigation.html
         //Router.replace() pushes a new route without history (this would be good for loading screen as well)
          //Will mean that on pressing the back button it won't return to that screen.
          //Hopefully this also means that the page won't be reloaded

          //Not sure it is entirely necessary though (it may be bound already --> Just the initial dashboard page won't be)
          console.log(newUserDb, newOrgDb); //eslint-disable-line

        //THIS MAY RESULT IN THE ROUTE REFRESHING --> WHICH WOULD BE BAD BUT WE NEED THE CENTRAL PARAMS TO BE KEPT UP TO DATE SOMEHOW
      }
    },
    computed: {
      sideBarStatus: {
        get(){
          if (this.mini) {
            return this.isSmallScreen();
          }
          return false;
        },
        set(newStatus) {
          return newStatus;
        }
      },
      drawerStatus: {
        get(){
          if (this.mini){
            return this.isSmallScreen();
          }
          return true;
        },
        set(newStatus){
          return newStatus;
        }
      },
      currentUserEmail(){
        return this.$route.params.user.email;
      },
      organisationName(){
        return this.localOrgDb.name;
      },
      hasOrganisation(){
        if (this.localUserDb) {
          if (this.localUserDb.orgid && this.localOrgDb) {
            return true;
          } 
        }
        return false;
      }
    },
    watch: {
      userDb: {
        // the callback will NOT be called immediately after the start of the observation
        immediate: true,
        handler (val) {
            if (val !== null){
                this.localUserDb = val;
                //Call function to update the current $route.params
                this.UpdateRouteParams(this.localUserDb, this.localOrgDb);
            }
        }
      },
      orgDb: {
        // the callback will NOT be called immediately after the start of the observation
        immediate: true, 
        handler (val) {
            if (val !== null){
                this.localOrgDb = val;
                //Call function to update the current $route.params
                this.UpdateRouteParams(this.localUserDb, this.localOrgDb);
            }
        }
      }
    }
  }
</script>